
<header class="row  shadow mx-1 mb-3 rounded">
    <div class="col ">
      <img [src]="logoImage" class="img-fluid" alt="NV header logo picture"/>
    </div>
    <div class="col-8 text-center">
      <p></p>
      <h1 class=" fw-bold">
        Nevada HIPP Program Online Application</h1>

      <strong>Fill out this form and click Submit to apply.</strong>

      <p>If you prefer to download a Nevada HIPP Program Application
        <a style="color: #0c69f2;" class="anchor" lang="en" href="javascript:void(0)" (click)="openPaperApplication()"
        download aria-label="download Nevada HIPP Program Application">download application</a>
      </p>
    </div>
    <div class="col-2 "></div>
  </header>
  <br />

  <main>
    <app-nvform  [preference]="preference"
      [errorMessageIntialData]="errorMessageIntialData" [email]="email" [address]="address" [emailTo]="emailTo"
      [faxNo]="faxNo" [tollfreeNo]="tollfreeNo"></app-nvform>
  </main>
  <footer class="text-center " style="background-color: #f1f1f1;">
    <div class="bg-light text-center ">

      <br />

      <p>
        Email <a target="_blank" [href]="emailTo" alt="Email" title="email" lang="en" style="color: #064EBA;">{{email}}</a> |
        Fax {{faxNo}} | Phone {{tollfreeNo}} | Mail to {{address}}
      </p>
    </div>

    <div class="text-center p-3 bg-secondary bg-opacity-50 bg-gradient">
      <p class="text-dark">HMS, Inc. All Rights Reserved</p>
    </div>
  </footer>
  <nv-app-scroll-top></nv-app-scroll-top>

